export interface JobBaseDependencyParams {
  definitionId: string
  dependencyId: string
  description?: string
  name?: string
  optional?: boolean
}

export abstract class JobBaseDependency {
  public definitionId: string
  public dependencyId: string
  public description?: string
  public name?: string
  public optional?: boolean

  protected constructor (params: JobBaseDependencyParams) {
    this.definitionId = params.definitionId
    this.dependencyId = params.dependencyId
    this.description = params.description
    this.name = params.name
    this.optional = params.optional
  }

  public get key (): string {
    return this.dependencyId
  }
}
